import editTaskTemplate from './editTask.html';

export default angular
  .module('main.locations.edit.tabs.editTask', [])

  .directive('editLocationEditTaskTab', () => {
    return {
      restrict: 'E',
      template: editTaskTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $filter,
                   utils,
                   config,
                   EditLocationDataProvider,
                   ToastsService,
                   I18nService) => {
        const $t = $filter('translate');
        const locale = I18nService.getLocale()?.code || 'en';

        $scope.dataProvider = EditLocationDataProvider.instance;
        $scope.isTaskEditable = false;
        $scope.isNewTask = false;
        $scope.loading = true;

        $scope.selectedTaskCreatedByUser = undefined;
        $scope.selectedTaskAssignedToUser = undefined;
        $scope.selectedTaskIcon = undefined;

        $scope.dueDisplayDatePickerOptions = {
          language: locale,
          position: 'bottom left',
          autoClose: true,
          view: 'days',
          minView: 'days',
          dateFormat: 'DD, MM d',
          minDate: new Date(),
          timepicker: false,
          clearButton: true
        };
        $scope.dueDateDatePickerOptions = {
          language: locale,
          position: 'bottom left',
          autoClose: true,
          view: 'days',
          minView: 'days',
          dateFormat: 'yyyy-mm-dd',
          minDate: new Date(),
          timepicker: false,
          clearButton: true
        };

        $scope.taskPriorities = [0, 1, 2, 3].map(n => ({
          id: n,
          name: $t(`locations.edit.tasks.priorities.${n}`)
        }));

        $scope.taskIcons = config.getConfigByKey('taskIcons')
          .map((i) => ({ id: i, name: utils.translateOrDefault(`locations.edit.tasks.icons.${i}`, i) }));

        angular.extend($scope, {
          getUserNameById: getUserNameById,
          onSaveButtonClick: onSaveButtonClick,
          onCancelButtonClick: onCancelButtonClick
        });

        init();

        function init() {
          $scope.loading = true;

          if (!$scope.dataProvider.taskToEdit) {
            $scope.dataProvider.taskToEdit = {
              id: utils.generateUUID(),
              editable: true
            };
            $scope.isNewTask = true;
          }

          initWatchers();
          initForm();

          $q.all([
            $scope.dataProvider.isLocationTasksEditableResource.init(),
            $scope.dataProvider.locationTaskUsersResource.init(),
            $scope.dataProvider.locationTasksResource.init()
          ])
            .then(() => {
              initTaskIcons();
              initViewModel();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initForm() {
          $('#form-new-task').form({
            inline: true,
            fields: {
              'task-title': {
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('locations.edit.tasks.title-validate')
                  }
                ]
              }
            }
          });
        }

        function initWatchers() {
          $scope.$on('$destroy', () => {
            $scope.dataProvider.taskToEdit = undefined;
            $scope.task = undefined;
          });

          $scope.$watchGroup([
            'task',
            'task.editable',
            'dataProvider.isLocationTasksEditableResource.value'
          ], () => {
            $scope.isTaskEditable = !!$scope.task
              && $scope.task.editable === true
              && $scope.dataProvider.isLocationTasksEditableResource.value === true;
          });

          $scope.$watch('dataProvider.locationTaskUsersResource.value', () => {
            $scope.taskUsers = ($scope.dataProvider.locationTaskUsersResource.value || [])
              .map((user) => {
                return {
                  ...user,
                  fullUserName: utils.getUserNameOrEmail(user) // we need this for dropdowns
                };
              });
          });
        }

        function initViewModel() {
          let taskToEdit = $scope.dataProvider.taskToEdit;

          $scope.task = {
            ...taskToEdit,

            // Transform text date format into date object
            due_display: taskToEdit.due_display
              ? moment(taskToEdit.due_display, 'dddd, MMMM D').toDate()
              : undefined,
            due_date: taskToEdit.due_date
              ? moment(taskToEdit.due_date, 'YYYY-MM-DD').toDate()
              : undefined
          };
        }

        function initTaskIcons() {
          let tasks = $scope.dataProvider.locationTasksResource.value;
          if (tasks && tasks.length > 0) {
            // Add unknown icons to the list
            tasks.forEach(task => {
              if (task.icon && !$scope.taskIcons.some(i => i.id === task.icon)) {
                $scope.taskIcons.push({
                  id: task.icon,
                  name: utils.translateOrDefault(`locations.edit.tasks.icons.${task.icon}`, task.icon)
                });
              }
            });
          }
        }

        /**
         * Get User Name (or other human-readable user description) by user id
         * @param {number} userId
         * @return {string|undefined}
         */
        function getUserNameById(userId) {
          if (!userId || !$scope.taskUsers) {
            return;
          }
          let user = $scope.taskUsers
            .find(u => u.id && u.id.toString() === userId.toString());
          return user ? utils.getUserNameOrEmail(user) : undefined;
        }

        function onSaveButtonClick() {
          $('#form-new-task').form('validate form');
          if (!$scope.isTaskEditable || $scope.loading || !$('#form-new-task').form('is valid')) {
            return;
          }

          let taskToSave = {
            ...angular.copy($scope.task), // to remove $$ angular stuff

            // Fix date format
            due_display: $scope.task.due_display ? moment($scope.task.due_display).format('dddd, MMMM D') : undefined,
            due_date: $scope.task.due_date ? moment($scope.task.due_date).format('YYYY-MM-DD') : undefined
          };

          $scope.loading = true;
          return $scope.dataProvider.saveLocationTask(taskToSave)
            .then(() => {
              $scope.loading = false;
              $scope.dataProvider.taskToEdit = undefined;
              $scope.task = undefined;
              $scope.dataProvider.activeTab = 'dashboard';
              ToastsService.success();
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function onCancelButtonClick() {
          if ($scope.loading) {
            return;
          }
          $scope.dataProvider.taskToEdit = undefined;
          $scope.task = undefined;
          $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
        }
      }
    };
  })
  .name;
